import React from 'react';

const Modal = ({ show, closeModal, children }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-gray-900 bg-opacity-50"
                onClick={closeModal}
            />
            {/* Close button */}
            <div className="absolute top-0 right-0 px-6 py-3 cursor-pointer z-10" onClick={closeModal}>
                <div className="h-6 w-6 text-white hover:text-gray-300">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </div>
            </div>
            {/* Modal content */}
            <div
                className="relative z-10 w-full sm:w-auto sm:max-w-2xl mx-4 sm:mx-6 bg-white rounded-md overflow-hidden overflow-y-auto max-h-[85vh]"
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    )
}

export default Modal;